<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/france')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/chateau-beaucastel')">Château Beaucastel</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/chateau-rayas')">Château Rayas</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/clos-des-papes')">Clos des Papes</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/delas-freres')">Delas Freres</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/domaine-de-la-janasse')">Domaine de la Janasse</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/etienne-guigal')">Etienne Guigal</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/henri-bonneau')">Henri Bonneau</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/jean-louis-chave')">Jean-Louis Chave</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/m-chapoutier')">M. Chapoutier</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/paul-jaboulet-aine')">Paul Jaboulet Ainé</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/pierre-usseglio')">Pierre Usseglio</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone/rene-rostaing')">René Rostaing</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/france')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile show-mobile-select"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div class="wine-guide-right">
                    <div class="howto-title">Rhone</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Rhone",
        data () {
            return {
                select: { report: 'Please choose', src: '#' },
                items: [
                    { report: 'Château Beaucastel', src: '/wine-guide/france/rhone/chateau-beaucastel' },
                    { report: 'Château Rayas', src: '/wine-guide/france/rhone/chateau-rayas' },
                    { report: 'Clos des Papes', src: '/wine-guide/france/rhone/clos-des-papes' },
                    { report: 'Delas Freres', src: '/wine-guide/france/rhone/delas-freres' },
                    { report: 'Domaine de la Janasse', src: '/wine-guide/france/rhone/domaine-de-la-janasse' },
                    { report: 'Etienne Guigal', src: '/wine-guide/france/rhone/etienne-guigal' },
                    { report: 'Henri Bonneau', src: '/wine-guide/france/rhone/henri-bonneau' },
                    { report: 'Jean-Louis Chave', src: '/wine-guide/france/rhone/jean-louis-chave' },
                    { report: 'M. Chapoutier', src: '/wine-guide/france/rhone/m-chapoutier' },
                    { report: 'Paul Jaboulet Ainé', src: '/wine-guide/france/rhone/paul-jaboulet-aine' },
                    { report: 'Pierre Usseglio', src: '/wine-guide/france/rhone/pierre-usseglio' },
                    { report: 'René Rostaing', src: '/wine-guide/france/rhone/rene-rostaing' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Rhone fine wine | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Discover the rich, diverse wine offerings of the Rhone wine region. From bold reds made with Syrah grapes to crisp whites made with Viognier, this region is sure to impress any wine lover. Explore the unique terroirs and taste the unforgettable flavors of Rhone\'s finest wines.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }


</style>
